import { ShowNotification } from 'src/components/common/ShowNotification/ShowNotification';

export const isPssValid = (isPss: boolean, principal: number, pssAbsolute: number) => (pssAbsoluteRequired(isPss, principal) && pssAbsolute > 0) || !pssAbsoluteRequired(isPss, principal);
export const pssAbsoluteRequired = (isPss: boolean, principal: number) => (isPss && principal === 0);

export const validatePssAndShowMessage = (isPss: boolean, principal: number, pssAbsolute: number) => {
    if (!isPssValid(isPss, principal, pssAbsolute)) {
        ShowNotification.Error("Falha ao recalcular","Informe o PSS Absoluto equivalente a 11% do principal");

        return false;
    }
    return true;
}


// WEBPACK FOOTER //
// ./src/util/pssHelper.ts